import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';

const ConnectWallet = () => {
  return (
    <WalletMultiButton />
  );
};

export default ConnectWallet;
